module.exports = __webpack_public_path__ + "static/img/07_tag.aa66a3b.png";